module.exports = __webpack_public_path__ + "img/people.71f237ed.svg";